import { Full } from './percentages';
import { CSSProperties } from '@mui/material/styles/createMixins';
import { Colors } from '.';

export const Fullscreen: CSSProperties = {
  height: Full,
  width: Full,
};

export const FullscreenView: CSSProperties = {
  height: '100vh',
  width: '100vw',
  minHeight: Full,
  overflowY: 'auto',
};

export const BackgroundImage: CSSProperties = {
  backgroundImage: 'url("/images/hexagonBackgroundFaded.webp")',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundAttachment: 'fixed',
};

export const MobileLoginBackgroundImage: CSSProperties = {
  backgroundImage: 'linear-gradient(to bottom, #e7f7fa, #f9cdbd)',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundAttachment: 'fixed',
};

export const DesktopLoginBackgroundImage: CSSProperties = {
  backgroundColor: Colors.primaryLighter,
  backgroundPosition: 'bottom left',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'auto 100vh',
  backgroundAttachment: 'fixed',
};

export const EmbeddedListItem: CSSProperties = {
  padding: 2,
  borderRadius: 2,
  border: `1px solid ${Colors.primaryLightest}`,
  paddingTop: '14px',
  paddingBottom: '14px',
  paddingRight: '20px',
  alignContent: 'center',
};

export const DrawerWidth = '40%';

export const HexGridContainer: CSSProperties = {
  'flexWrap': 'wrap',
  'display': 'flex',
  'width': '90%',
  'margin': '0 auto',
  'paddingLeft': '25px',
  'overflow': 'hidden',
  'listStyleType': 'none',
  '&.nested': {
    marginTop: '-140px',
  },
  '& .content-wrapper': {
    'filter': 'drop-shadow(-1px 6px 8px rgba(30, 41, 105, 0.5))',
    'transform': 'translate3d(0, 0, 0)',
    '&:nth-of-type(odd)': {
      marginTop: '133px',
    },
  },
};

// #1b7690
export const HexGridItemContainer: CSSProperties = {
  'position': 'relative',
  'background': '#1b7690',
  'height': '146px',
  'width': '127px',
  'boxShadow': '6px 6px 17px 0 #000',
  //'overflow': 'hidden',
  'transform': 'rotate(90deg)',
  'clipPath': 'polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%)',
  '&::after': {
    content: '""',
    display: 'block',
    paddingBottom: '90%',
  },
  '& .content': {
    cursor: 'pointer',
    width: '121px',
    height: '140px',
    background: '#fff',
    position: 'absolute',
    top: '3.2px',
    left: '2.7px',
    clipPath: 'polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%)',
  },
  '& .content:hover': {
    background: Colors.disabledLight,
  },
  '& .icon, .text': {
    position: 'absolute',
    transform: 'rotate(-90deg)',
  },
  '& .icon': {
    top: '32%',
    left: '15%',
  },
  '& .text': {
    top: '36%',
    left: '34%',
    width: '87px',
    height: '39px',
    textAlign: 'center',
  },
};

export const StateHexagonContainer: CSSProperties = {
  'flexWrap': 'wrap',
  'display': 'flex',
  'width': '90%',
  'margin': '0 auto',
  'paddingLeft': '25px',
  'overflow': 'hidden',
  'listStyleType': 'none',
  '&.nested': {
    marginTop: '-140px',
  },
  '& .content-wrapper': {
    'filter': 'drop-shadow(-1px 6px 8px rgba(30, 41, 105, 0.5))',
    '&:nth-of-type(odd)': {
      marginTop: '133px',
    },
  },
  '& .content:hover': {
    '& .hexagon': {
      opacity: 0.8,
      cursor: 'default',
      zIndex: 9999999,
    },
  },
  '& .show-on-hover': {
    display: 'none',
  },
  '&:hover': {
    '& .show-on-hover': {
      display: 'inline',
      opacity: 1,
    },
  },
};

export const StateHexagonOuterItemContainer: CSSProperties = {
  'clipPath': 'polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%)',
  'backgroundColor': '#ffffff',
  'position': 'absolute',

  '& .content': {
    cursor: 'pointer',
    position: 'absolute',
    clipPath: 'polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%)',
  },
};
export const StateHexagonInnerItemContainer: CSSProperties = {
  'clipPath': 'polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%)',
  'position': 'absolute',

  '& .content': {
    cursor: 'pointer',
    position: 'absolute',
    clipPath: 'polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%)',
  },
};

export const StateHoverModal: CSSProperties = {
  'position': 'relative',
  'zIndex': 999,
  'borderRadius': '14px',
  'boxShadow': '0 0 15px #1e296933',
  'alignItems': 'center',
  'textAlign': 'center',
  'flexGrow': 5,
  'display': 'flex',
  'marginTop': -3,
  'marginLeft': 4,
  'minWidth': '150px',
  'backgroundColor': '#ffffff',
  'opacity': '1 !important',
  '&:hover': {
    opacity: 1,
  },
};

export const ShowGroupDeleteOnHover: CSSProperties = {
  '& .group-edit-delete': { 'opacity': 0, '& button': { padding: 0 } },
  '&:hover': {
    '& .group-edit-delete': { opacity: 1 },
  },
};
